import { CreateRealtyScreenContent } from "../../features/createRealty";

// Thin route wrapper — mirrors RealtyEditScreen / RealtyDetailScreen /
// RealtyHomeScreen. Route shell only: the .add-property-page #Csection
// envelope + full wizard + local state all live INSIDE the feature widget.

function RealtyCreateScreen() {
  return <CreateRealtyScreenContent />;
}

export default RealtyCreateScreen;
